module.exports = __webpack_public_path__ + "static/image-biersafe-m-a4c43131b721fccacf6543f9d9cf9c6d.png";